var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('van-empty',{attrs:{"description":""}}),_c('h1',[_vm._v("尊敬的用户：您访问的网站尚未授权")]),_c('br'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" 技术支持: "),_c('a',{staticClass:"link",attrs:{"href":"www.xunijiang.com","target":"_blank"}},[_vm._v("虚拟匠数字产品销售系统科技")])])
}]

export { render, staticRenderFns }